const DELIVERY_FAILURE_STATUSES = new Set(["failed", "undelivered"]);

const normalizeStatus = (status) =>
  String(status ?? "")
    .trim()
    .toLowerCase();

const hasErrorCode = (errorCode) =>
  String(errorCode ?? "").trim() !== "" && String(errorCode).trim() !== "0";

export const isMessageUndelivered = (message) => {
  const status = normalizeStatus(message?.status);

  if (status) {
    return DELIVERY_FAILURE_STATUSES.has(status);
  }

  // Some legacy messages predate delivery statuses. Preserve their real
  // provider errors without treating null/undefined error codes as failures.
  return hasErrorCode(message?.error_code);
};
